import React, { useEffect, useState } from 'react'
import Layout from '../Layout'
import { Box, Button, CircularProgress, Container, FormControl, Grid, InputLabel, MenuItem, Paper, Select, TextField, Typography, makeStyles } from '@material-ui/core'
import { useLocation, useNavigate } from 'react-router-dom'
import CustomBreadcrumbs from '../Breadcrumb'
import NotInterestedIcon from '@material-ui/icons/NotInterested';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import { useDispatch } from 'react-redux';
import { getBd_category, getBd_reason, getUserReadable, postBD_Category, postBD_Reasons, reportBreakDown } from '../../ReduxStore/Breakdown/BreakdownSlice';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { GridLoadingSpinner } from '@tmlconnected/avant-garde-components-library'

const useStyles = makeStyles((theme) => ({
    root: {
        padding: theme.spacing(4),
        maxWidth: 700,
        margin: '0 auto',
        paddingBlock: 30,
        marginTop: 10,
        marginBottom: 10
    },
    form: {
        display: 'flex',
        flexDirection: 'column',
    },
    formControl: {
        marginBottom: theme.spacing(2),
    },
    button: {
        marginTop: theme.spacing(2),
    },
    lowPriority: {
        color: 'green',
    },
    mediumPriority: {
        color: 'yellow',
    },
    highPriority: {
        color: 'red',
    },
}));

const AddDetails = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const classes = useStyles();
    const location = useLocation();
    const pathname = location.pathname.split('/');
    const asset_id = pathname[3];

    const breadcrumbsLinks = [
        { label: 'Home', href: '/' },
        // { label: 'Reporting', href: '/trigger-breakdown' },
        { label: 'Select Asset for Reporting Breakdown', href: '/report-breakdown/select-asset' },
    ];

    const [postLoading, setPostLoading] = useState(false);
    const [saveLoading, setSaveLoading] = useState(false);
    const [loading, setLoading] = useState(true);
    const [customerId, setCustomerId] = useState("");
    const [Category, setCategory] = useState([]);
    const [Reasons, setReasons] = useState([]);
    const [SelectedReason, setSelectedReason] = useState("");
    const [priority, setPriority] = useState("");
    const [comment, setComment] = useState("");
    const [nature, setNature] = useState("");
    const [customCategory, setCustomCategory] = useState("");
    const [isOtherSelected, setIsOtherSelected] = useState(false);
    const [category_id, setCategory_id] = useState("");
    // const [customReason, setCustomReason] = useState([]);
    const [customReason, setCustomReason] = useState([
        { name: "", category_id: category_id }]
    );
    const [isOtherReasonSelected, setisOtherReasonSelected] = useState(false);
    const [filteredReasons, setFilteredReasons] = useState([]);


    // const flattenedReason = Reasons && Reasons.flat();
    // console.log("res", flattenedReason);

    const handleSubmit = async (e) => {
        e.preventDefault();
        console.log("reasons check",SelectedReason)
        // 🔴 Validation for reason
        if (!SelectedReason || SelectedReason === "other") {
            toast.error("Please select a valid/specific reason.");
            return;
        }
        
        const payload = {
            asset_id: asset_id,
            customer_id: customerId,
            priority: priority,
            reason_id: SelectedReason,
            comments: comment
        }

        try {
            setPostLoading(true)
            const action = dispatch(reportBreakDown(payload));
            const res = await action.unwrap();
            console.log("res", res.result)
            if (res.result) {
                setPostLoading(false)
                toast.success("BreakDown Reported Successfully!");
                setTimeout(() => {
                    navigate("/breakdown-management")
                }, 2000);
            }
        } catch (error) {
            console.error("Error in okHandler:", error);
            toast.error(error.message || "Something went wrong!");
        } finally {
            setPostLoading(false)
        }


        // const currentDate = new Date().toISOString().split('T')[0];
        // const newFormData = {
        //     ...formData,
        //     date: currentDate
        // };
        // console.log('Form submitted:', newFormData);

        // let reports = JSON.parse(localStorage.getItem("report")) || [];

        // const newReport = {
        //     id: generateUniqueId(),  // Add unique identifier
        //     assetNo: newFormData.assetNo,
        //     rfidNo: rfidNo,
        //     partNo: partNo,
        //     assetDescription: formData.assetDescription,
        //     nature: newFormData.nature,
        //     reason: newFormData.reasons,
        //     priority: newFormData.priority,
        //     comment: newFormData.comment,
        //     date: newFormData.date
        // };
        // reports.push(newReport);
        // localStorage.setItem("report", JSON.stringify(reports));
        // navigate('/report-breakdown');
    };

    // Handle category selection
    const handleCategoryChange = (e) => {
        const selectedValue = e.target.value;
        setNature(selectedValue);
        if (selectedValue === "other") {
            setIsOtherSelected(true);  // Show custom category text field
        } else {
            setIsOtherSelected(false);
            setCategory_id(selectedValue)
            const filtered = Reasons.filter(reason => reason.category_id === selectedValue);
            const reasonWithOther = [...filtered, { name: "Other", id: "other" }];
            setFilteredReasons(reasonWithOther);
        }
    };
    // Handle category selection
    const handleReasonChange = (e) => {
        const selectedValue = e.target.value;
        setSelectedReason(selectedValue);
        if (selectedValue === "other") {
            setisOtherReasonSelected(true);  // Show custom category text field
        } else {
            setisOtherReasonSelected(false);  // Hide custom category text field
        }
    };

    // Handle Save for custom category
    const handleSaveCustomCategory = async () => {
        if (customCategory) {
            const payload = {
                categories: [customCategory],
                customer_id: customerId
            };
            console.log("Payload to send:", payload);
            try {
                setSaveLoading(true)
                const action = dispatch(postBD_Category(payload));
                const res = await action.unwrap();
                console.log("res", res)
                if (res.StatusCode === 201) {
                    getCategory(customerId);
                    setSaveLoading(false)
                    setIsOtherSelected(false);
                    toast.success("Category Added Successfully!");
                }
            } catch (error) {
                console.error("Error in okHandler:", error);
                toast.error(error.message || "Something went wrong!");
            } finally {
                setSaveLoading(false)
            }
        } else {
            toast.error("Please enter a valid custom category");
        }
    };

    const handleSaveReasonCategory = async () => {
        console.log("checkkk:", customReason);
        if (customReason) {
            const payload = {
                reasons: customReason.map(item => (
                    {
                        name: item.name,
                        category_id: category_id
                    }
                )), 
                customer_id: customerId
            };
            console.log("Payload to send:", payload);
            try {
                setSaveLoading(true)
                const action = dispatch(postBD_Reasons(payload));
                const res = await action.unwrap();
                console.log("res", res)
                if (res.StatusCode === 201) {
                    getReasons(customerId);
                    setSaveLoading(false)
                    setisOtherReasonSelected(false);
                    toast.success("Reason Added Successfully!");
                }
            } catch (error) {
                console.error("Error in okHandler:", error);
                toast.error(error.message || "Something went wrong!");
            } finally {
                setSaveLoading(false)
            }
        } else {
            toast.error("Please enter a valid custom Reason");
        }
    };

    // Handle Cancel for custom category
    const handleCancelCustomCategory = () => {
        setIsOtherSelected(false);
        setCustomCategory("");
        setNature("");  // Reset the selection
    };


    const handleCancelReasonCategory = () => {
        setisOtherReasonSelected(false);
        setCustomReason("");
        setSelectedReason("");  // Reset the selection
    };

    const getCategory = async (id) => {
        try {
            const action = dispatch(getBd_category(id));
            const res = await action.unwrap();
            console.log("res", res.result)
            if (res.result) {
                const categoriesWithOther = [...res.result.bd_category, { id: "other", category: "Other" }];
                setCategory(categoriesWithOther);
                // setCategory(res.result.bd_category)
            }
        } catch (error) {
            console.error("Error in okHandler:", error);
            toast.error(error.message || "Something went wrong!");
        }
    };
    const getReasons = async (id) => {
        try {
            const action = dispatch(getBd_reason(id));
            const res = await action.unwrap();
            console.log("res", res.result)
            if (res.result) {
                const reasons = res.result.bd_reasons
                const flattenedReason = reasons.flat();
                setReasons(flattenedReason)
                if (category_id) {
                const filtered = flattenedReason.filter(
                    (reason) => reason.category_id === category_id
                );

                const reasonWithOther = [
                    ...filtered,
                    { name: "Other", id: "other" },
                ];

                setFilteredReasons(reasonWithOther);
            }
            }
        } catch (error) {
            console.error("Error in okHandler:", error);
            toast.error(error.message || "Something went wrong!");
        }
    }
    const UserReadeable = async () => {
        try {
            const action = dispatch(getUserReadable());
            const res = await action.unwrap();
            console.log("res", res.result.user.customerId)
            if (res.result) {
                setCustomerId(res.result.user.customerId)
                const customer_id = res.result.user.customerId;
                if (customer_id) {
                    await getCategory(customer_id);
                    await getReasons(customer_id)
                }
            }
        } catch (error) {
            console.error("Error in okHandler:", error);
            toast.error(error.message || "Something went wrong!");
        }
    }


    useEffect(() => {
        const fetchData = async () => {
            await UserReadeable();
            // await getReasons();
            setLoading(false);
        };
        fetchData();
    }, [])


    if (loading) {
        return (
          <Layout>
            <Container>
              <Box mt={4} display="flex" justifyContent="center" alignItems="center" minHeight="80vh" >
                <GridLoadingSpinner />
              </Box>
            </Container>
          </Layout>
        );
      }

    return (
        <Layout>
            <Container>
                {/* <Box mt={1}>
                    <Typography variant="h3" component="h1" gutterBottom>
                        Add Details
                    </Typography>
                </Box> */}
                <Box mt={1} mb={3}>
                    <CustomBreadcrumbs links={breadcrumbsLinks} current="Add Details" />
                </Box>
                <Box>
                    <Paper className={classes.root}>
                        <form className={classes.form} onSubmit={handleSubmit} >
                            <Grid container spacing={3} >
                                <Grid item xs={12}>
                                    <FormControl variant="filled" fullWidth>
                                        <InputLabel>Nature of Breakdown</InputLabel>
                                        <Select
                                            className={classes.formControl}
                                            value={nature}
                                            // onChange={(e) => setNature(e.target.value)}
                                            onChange={handleCategoryChange}
                                            label="Nature"
                                            name="nature"
                                        >
                                            {Category && Category.map((item, index) => (
                                                <MenuItem value={item.id} key={index}>{item.category}</MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                    {isOtherSelected && (
                                        <div style={{ marginTop: "20px" }}>
                                            <TextField
                                                fullWidth
                                                variant="outlined"
                                                label="Enter Custom Category"
                                                value={customCategory}
                                                onChange={(e) => setCustomCategory(e.target.value)}
                                            />
                                            <div style={{ marginTop: "10px", display: "flex", justifyContent: "flex-end" }}>
                                                <Button
                                                    variant="contained"
                                                    color="primary"
                                                    onClick={handleSaveCustomCategory}
                                                    style={{ marginRight: "10px" }}
                                                    startIcon={saveLoading && <CircularProgress size={20} />}
                                                    disabled={saveLoading}
                                                >
                                                    {saveLoading ? "Saving" : "Save"}
                                                </Button>
                                                <Button variant="outlined" color="secondary"
                                                    onClick={handleCancelCustomCategory}>
                                                    Cancel
                                                </Button>
                                            </div>
                                        </div>
                                    )}
                                </Grid>
                                {filteredReasons.length > 0 && <Grid item xs={12}>
                                    <FormControl variant="filled" fullWidth>
                                        <InputLabel>Select Reasons</InputLabel>
                                        <Select
                                            className={classes.formControl}
                                            value={SelectedReason}
                                            // onChange={(e) => setSelectedReason(e.target.value)}
                                            onChange={handleReasonChange}
                                            label="Reasons"
                                            name="reason_id"
                                        >
                                            {filteredReasons && filteredReasons.map((item, index) => (
                                                <MenuItem key={index} value={item.id}>{item.name}</MenuItem>
                                            ))}


                                        </Select>
                                    </FormControl>
                                    {isOtherReasonSelected && (
                                        <div style={{ marginTop: "20px" }}>
                                            <TextField
                                                fullWidth
                                                variant="outlined"
                                                label="Enter Custom Reason"
                                                // value={customReason[0].name}
                                                value={customReason?.[0]?.name || ""}
                                                onChange={(e) =>
                                                    setCustomReason([{ ...customReason[0], name: e.target.value }])
                                                }

                                            />
                                            <div style={{ marginTop: "10px", display: "flex", justifyContent: "flex-end" }}>
                                                <Button
                                                    variant="contained"
                                                    color="primary"
                                                    onClick={handleSaveReasonCategory}
                                                    style={{ marginRight: "10px" }}
                                                    startIcon={saveLoading && <CircularProgress size={20} />}
                                                    disabled={saveLoading}
                                                >
                                                    {saveLoading ? "Saving" : "Save"}
                                                </Button>
                                                <Button variant="outlined" color="secondary"
                                                    onClick={handleCancelReasonCategory}>
                                                    Cancel
                                                </Button>
                                            </div>
                                        </div>
                                    )}
                                </Grid>}
                                <Grid item xs={12}>
                                    <FormControl variant="filled" fullWidth>
                                        <InputLabel>Select Breakdown Priority</InputLabel>
                                        <Select
                                            className={classes.formControl}
                                            value={priority}
                                            onChange={(e) => setPriority(e.target.value)}
                                            label="Priority"
                                            name="priority"
                                            MenuProps={{
                                                classes: {
                                                    paper: classes.selectPaper,
                                                },
                                            }}
                                        >
                                            <MenuItem value="low" className={classes.lowPriority}>
                                                Low
                                            </MenuItem>
                                            <MenuItem value="medium" className={classes.mediumPriority}>
                                                Medium
                                            </MenuItem>
                                            <MenuItem value="high" className={classes.highPriority}>
                                                High
                                            </MenuItem>
                                        </Select>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12}>
                                    <TextField
                                        className={classes.formControl}
                                        label="Comment"
                                        name="comments"
                                        value={comment}
                                        onChange={(e) => setComment(e.target.value)}
                                        variant="filled"
                                        fullWidth
                                        multiline
                                        minRows={4}
                                    />
                                </Grid>
                            </Grid>
                            <Grid container spacing={3}>
                                <Grid item xs={6} sm={6}>
                                    <Button
                                        className={classes.button}
                                        variant="contained"
                                        fullWidth
                                        startIcon={<NotInterestedIcon />}
                                        onClick={() => navigate('/report-breakdown/select-asset')}
                                    >
                                        Discard
                                    </Button>
                                </Grid>
                                <Grid item xs={6} sm={6}>
                                    <Button
                                        className={classes.button}
                                        type="submit"
                                        variant="contained"
                                        color="primary"
                                        fullWidth
                                        startIcon={postLoading ? <CircularProgress size={20} /> : <CheckCircleIcon />}
                                        disabled={postLoading}
                                    >
                                        {postLoading ? "Submitting" : "Submit"}
                                    </Button>
                                </Grid>
                            </Grid>
                        </form>
                    </Paper>
                </Box>
            </Container>
            <ToastContainer />
        </Layout >
    )
}

export default AddDetails